const reducer = (state: any, action: any) => {
  const { type, data } = action;
  switch (type) {
    case 'SET_SORTBY':
      return {
        ...state,
        queryParam: {
          ...state.queryParam,
          sortBy: data,
        },
      };

    case 'SET_FILTER':
      return {
        ...state,
        queryParam: {
          ...state.queryParam,
          rating: [...data] || [],
        },
      };

    case 'SET_DATA':
      return {
        ...state,
        data: {
          ...state.data,
          total: data?.total ? data.total : 0,
          reviews: data?.reviews ? [...data.reviews] : [],
          comments: data?.comments ? data?.comments : 0,
        },
      };
    case 'SET_OFFSET':
      return {
        ...state,
        queryParam: {
          ...state.queryParam,
          offset: data || 0,
        },
      };

    case 'SET_FETCH_MORE_LOADING':
      return {
        ...state,
        data: {
          ...state.data,
          fetchMoreLoading: data,
        },
      };

    default:
      throw new Error('Reducer says: Action type not found');
  }
};

export default reducer;
export { reducer };
